import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/utils.ts";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Вставляет в мапу нод новую ноду, но детей children берет из старой
 * Полезно когда в сторе хранится полученная с populated эндпоинта нода и мы запросили не populated ноду
 */
export function updateWithOldChildren(nodes, newNode) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var next = _objectSpread({}, nodes);

  if (newNode instanceof Array) {
    newNode.forEach(function (n) {
      var oldNode = next[n.id];

      if (oldNode) {
        next[n.id] = _objectSpread(_objectSpread({}, n), {}, {
          children: oldNode.children
        });
      } else {
        next[n.id] = n;
      }
    });
  } else {
    var oldNode = next[newNode.id];

    if (oldNode) {
      next[newNode.id] = _objectSpread(_objectSpread({}, newNode), {}, {
        children: oldNode.children
      });
    } else {
      next[newNode.id] = newNode;
    }
  }

  return next;
}